module.exports = __webpack_public_path__ + "static/media/dashboard_coming_soon.b522041d.png";